var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnekeyBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.43248,15.4245Q6.83173,13.3979,4.4171499999999995,14.8466Q1.841288,16.3921,2.726327,18.432000000000002C2.776428,18.5475,2.843238,18.6559,2.915827,18.7587L8.50148,26.6717C8.96992,27.3353,9.73159,27.73,10.5439,27.73L25,27.73C26.3807,27.73,27.5,26.6107,27.5,25.23L27.5,16.5392C27.5,15.5169,26.8776,14.5976,25.9285,14.218L19.4478,11.62575L19.4478,6.25766Q18.911,2.5,15.6901,2.5Q12.46929,2.5,11.93249,6.25766L11.93249,14.3138L11.93248,18.0674L10.01532,15.9202Q9.72274,15.6507,9.43248,15.4245ZM8.23713,17.682299999999998Q7.35634,16.8932,6.68785,16.765Q6.22637,16.6765,5.70338,16.990299999999998Q5.23569,17.270899999999997,5.0581499999999995,17.4585L10.5439,25.23L25,25.23L25,16.5392L18.5193,13.9469C17.5702,13.5673,16.9478,12.648,16.9478,11.62575L16.9478,6.44853Q16.794600000000003,5.52958,16.4722,5.20718Q16.265,5,15.6901,5Q15.1153,5,14.9081,5.20718Q14.5857,5.52958,14.4325,6.4485399999999995L14.4325,18.0674C14.4325,19.4482,13.3132,20.5674,11.93248,20.5674C11.22032,20.5674,10.54195,20.2637,10.06764,19.7325L8.23713,17.682299999999998Z",
    fillRule: "evenodd",
    fill: "#27314D",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnekeyBlue);
export default __webpack_public_path__ + "static/media/onekey_blue.11ff6ed08b07e2158e0c260f151b1b70.svg";
export { ForwardRef as ReactComponent };